import { GetThreeDSChallengesReturn } from '@web/walter-lib/api'

// eslint-disable-next-line complexity
export const processChallenge = (ch: GetThreeDSChallengesReturn['challenges'][number]) => ({
    ...ch,
    id: ch.id || '',
    card_id: ch.card_id || '',
    merchant_data: {
        name: ch.merchant_name,
    },
    transaction_type: 'payment' as const,
    status: 'Authorized' as const,
    timeForRow: ch?.expires_at,
})
